import React, {useState, useEffect} from 'react';
import {Surface2} from '../Surface2/Surface2'
import {Surface3Wrapper} from '../Surface3Wrapper'
//import {Link} from 'react-router-dom';

import {runQuery} from '../utils'
import {getCodexInfo, getCodexInfoFromSurface, getCodexInfoFromCanvas, getCodexInfoFromManifest} from './queries'

interface MyComponentProps {
  resourceid: string,
  codexResourceType?: string,
  handleChangeInfo?: any,
  topLevel?: boolean
}

export const Codex: React.FC<MyComponentProps> = (props) => {
  const [items, setItems] = useState<any>({})
  const [title, setTitle] = useState<string>("")
  const [focusedSurface, setFocusedSurface] = useState<string>("")
  const [relatedCodices, setRelatedCodices] = useState<any[]>([])
  const [showContents, setShowContents] = useState<boolean>(true)
  const [surface3Manifestations, setSurface3Manifestations] = useState<any[]>([])
  const [surface3FocusedManifestation, setSurface3FocusedManifestation] = useState<string>("")
  
  
  const handleToggleShowContents = () => {
    setShowContents(!showContents)
  }
  
  
  const retrieveCodexInfo = (id: string, type: string) => {
    let codexInfo = undefined
    if (type === "surface"){
      codexInfo = runQuery(getCodexInfoFromSurface(id))
    }
    else if (type === "canvas"){
      codexInfo = runQuery(getCodexInfoFromCanvas(id))
    }
    else if (type === "manifest"){
      codexInfo = runQuery(getCodexInfoFromManifest(id))
    }
    else{
      codexInfo = runQuery(getCodexInfo(id))
    }
    codexInfo.then((d) => {
      const data = d.data.results.bindings
      if (data.length > 0 && data[0].surface){
        const expressionIdMap = data.map((d) => {
          return d.expression ? d.expression.value : ""
        })
        var unique = expressionIdMap.filter((v, i, a) => a.indexOf(v) === i);
        let expressionList = {}
        unique.forEach((e) => {
           expressionList[e] = []
        })
        data.forEach((d) => {
            const info = {
              expression: d.expression.value,
              expressionTitle: d.item_expression_title.value,
              manifestation: d.manifestation.value,
              surface: d.surface.value,
              surfaceTitle: d.surface_title.value,
              questionTitle: d.item_expression_question_title ? d.item_expression_question_title.value : ''
            }
          expressionList[d.expression.value].push(info)
        })
        let focusedSurface = ""
        if (type === "surface"){
           focusedSurface = id
         }
         else if (type === "canvas"){
           focusedSurface = data[0].surfaceFocus.value
         }
         else{
           focusedSurface = data[0].surface.value
         }
        //setItems(expressionList) I don't think this is needed here: TODO: remove state declaration above and then delete this line 
        setFocusedSurface(focusedSurface)
        props.handleChangeInfo(focusedSurface)
        

      }
    })
  }

  useEffect(()=> {
    retrieveCodexInfo(props.resourceid, props.codexResourceType)
  }, [props.resourceid])

  const displayImages = () => {
    if (surface3Manifestations.length > 0){
      return <Surface3Wrapper manifestations={surface3Manifestations} focusedManifestation={surface3FocusedManifestation} annotationsDisplay="paragraph" width="501" hidden={false}/>
    }
    else if (focusedSurface){
      return <Surface2 surfaceid={focusedSurface} lineFocusId="" topLevel={props.topLevel} handleChangeInfo={props.handleChangeInfo} width={"501"} annotationsDisplay={false}/>
      // return <div>Test working for {focusedSurface}</div>
    }
    else{
      return null
    }

  }

  return (
    <div className="codexImage">
        <h1>Codex Pages</h1>
        {displayImages()}
        </div>
  );
  
}


